<template>
  <div class="page">
    <div class="nav-wrapper">
      <Navbar />
    </div>
    <div class="page-wrapper">
      <div class="filter-wrapper">
        <div class="filter-container">
          <button
            type="button"
            class="link link--filter"
            @click="expertModalShow = true"
          >
            {{ $t('filter.expert_filter') }}
          </button>
          <button
            type="button"
            class="link link--filter"
            @click="dateFilterModalShow = true"
          >
            {{ $t('filter.date_filter') }}
          </button>
        </div>
        <div class="filter-container filter-container--auto">
          <SearchInput @update-search-value="filterEstimations" />
          <Sort :options="sortOptions" @action="filterEstimations" />
          <button
            type="button"
            class="button button--filter"
            :class="{ 'filter--active': !isList }"
            @click="setList(false)"
          >
            <i class="fas fa-th-large"></i>
          </button>
          <button
            type="button"
            class="button button--filter"
            :class="{ 'filter--active': isList }"
            @click="setList(true)"
          >
            <i class="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <div class="list-container" v-if="isList">
        <List :headers="headers">
          <tr v-for="(item, i) in estimations" :key="i" class="list__line">
            <td>{{ item.client.firstName }} {{ item.client.lastName }}</td>
            <td>{{ prettyFullDate(item.createdAt) }}</td>
            <td>{{ toCurrency(item.estimationValue) }}</td>
            <td>{{ prettyFullDate(item.estimatedAt) }}</td>
          </tr>
        </List>
      </div>
      <div class="filter-wrapper">
        <p>{{ $t('display_number_estimations') }} {{ totalEstimations }}</p>
      </div>
      <div class="card-container" v-if="!isList">
        <EstimationCard
          v-for="(estimation, i) in estimations"
          :key="i"
          :card="estimation"
          status="sent"
          @fullView="fullView"
        />
      </div>
      <InfiniteScroll
        v-if="estimations.length < totalEstimations"
        @paginate="paginateEstimations"
      />
    </div>
    <ExpertFilterModal
      v-if="expertModalShow"
      :selected-expert="estimations.expert"
      @closeModal="expertModalShow = false"
      @filter="expertFilter"
      @deleteExpertFilter="deleteEstimatedExpertFilter"
    />
    <DateFilterModal
      v-show="dateFilterModalShow"
      @closeModal="dateFilterModalShow = false"
      @filter="dateFilter"
      @eraseDateFilter="deleteDateFilter"
    />
  </div>
</template>

<script>
import { SearchInput, Sort, InfiniteScroll } from '../../components/filters';
import Navbar from '../../components/Navbar';
import EstimationCard from '../../components/EstimationCard';
import List from '../../components/List';
import { formatDate, formatNumber, EstimationComponent } from '../../mixins';
import { infiniteLoading } from '@/lib/customEvents';
import ExpertFilterModal from '@/components/filters/ExpertFilterModal';
import DateFilterModal from '@/components/filters/DateFilterModal';

export default {
  components: {
    DateFilterModal,
    ExpertFilterModal,
    Navbar,
    EstimationCard,
    List,
    SearchInput,
    Sort,
    InfiniteScroll,
  },

  mixins: [formatDate, formatNumber, EstimationComponent],

  data() {
    return {
      dateFilterModalShow: false,
      expertModalShow: false,
      isList: false,
      headers: ['fullname', 'reception-date', 'estimation', 'estimation.date'],
      sortOptions: [
        {
          title: 'filter.sort.newer',
          sortedElement: 'order[createdAt]',
          order: 'desc',
        },
        {
          title: 'filter.sort.older',
          sortedElement: 'order[createdAt]',
          order: 'asc',
        },
        {
          title: 'filter.sort.bigger_amount',
          sortedElement: 'order[estimationValue]',
          order: 'desc',
        },
        {
          title: 'filter.sort.lesser_amount',
          sortedElement: 'order[estimationValue]',
          order: 'asc',
        },
      ],
    };
  },

  async created() {
    await this.loadSentEstimations();
  },

  methods: {
    async loadSentEstimations() {
      const sentEstimations = await this.fetchEstimations({ status: 'estimated' });

      if (!sentEstimations || !sentEstimations['hydra:member']) return;

      this.estimations = sentEstimations['hydra:member'];

      if (!sentEstimations['hydra:totalItems']) return;

      this.totalEstimations = sentEstimations['hydra:totalItems'];
    },

    setList(value) {
      this.isList = value;

      if (this.isList) {
        this.$nextTick(() => document.dispatchEvent(infiniteLoading));
      }
    },
    dateFilter(dates) {
      this.filterEstimations({
        sortKey: 'createdAt[after]',
        value: dates[0],
      });
      this.filterEstimations({
        sortKey: 'createdAt[before]',
        value: dates[1],
      });
    },
    expertFilter(expert) {
      this.filterEstimations({
        sortKey: 'expert',
        value: expert[0].id,
      });
    },

    async deleteEstimatedExpertFilter() {
      this.eraseEstimatedExpertFilter();
      await this.loadSentEstimations();
    },

    async submitAssignation(expert) {
      await this.updateAssignation(this.card['@id'], expert);
      this.$emit('updateEstimation');
      this.expertModalShow = false;
    },

    async deleteDateFilter() {
      this.eraseDateFilter();
      await this.loadSentEstimations();
    },
  },
};
</script>
